<template>
  <div>
    <div
      class="search--wrapper"
      :class="{disabled: isDisabled, 'has-text': searchValue}"
    >
      <aha-input
        :placeholder="placeHolderInput"
        class="search__input"
        v-model="searchValue"
        @input="_onSearchInput"
        ref="search"
        @click="removeDisabled($event)"
        @focusout="unFocusSearch()"
        autocomplete="new-password"
      >
        <template #append>
          <aha-icon
            name="search"
            class="search__icon absolute top-0 flex items-center h-10 text-base-60 left-2"
            width="16"
            height="16"
            viewBox="0 0 24 24"
          />
          <aha-icon
            name="close"
            class="clear__icon"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            @click="_onClickClearSearch"
          />
        </template>
      </aha-input>
    </div>
  </div>
</template>
<script>
import debounce from 'debounce'
import { mapState } from 'vuex'
import constants from '@/constant'
import Config from '@/config'
import utils from '@/util'

export default {
  data() {
    return {
      searchValue: '',
    }
  },
  computed: {
    ...mapState({
      searchBy: (state) => state.search.searchBy,
    }),
    isDisabled() {
      return this.$route.name === 'Upgrade'
    },
    isEURegion() {
      return Config.region === constants.euRegion
    },
    placeHolderInput() {
      return this.$i18nPresenter.t('Search thousands of templates...')
    },
  },
  watch: {
    $route: function handleChangeRoute(newRoute) {
      if (newRoute.name === 'TemplateLibrary'
        && newRoute.query.category) {
        this.clearSearch()
      }
      if (newRoute.name === 'TemplateLibrary'
        && !newRoute.query.q) {
        this.clearSearch()
      }
    },
  },
  mounted() {
    if (this.$route.query.q && this.$route.query.q.length > 1) {
      this.searchValue = this.$route.query.q
    }
  },
  methods: {
    _onSearchInput: debounce(async function onSearchInputDebounce() {
      this.searchTemplate()
    }, 700),

    clearSearch() {
      this.searchValue = ''
    },

    async searchTemplate() {
      const query = {}
      const text = this.searchValue.trim()
      if (text.length !== 1) {
        if (!text.length) {
          query.from = 'clearSearch'
        } else if (text.length > 1) {
          query.q = this.searchValue
          query.from = 'searchBar'
        }
        this.$router.push({ name: 'TemplateLibrary', query })
      }
      utils.mixpanelTracking('Template library > Search template', 'Search Presentation', this.searchValue)
    },

    _onClickClearSearch() {
      this.clearSearch()
      this.searchTemplate()
    },

    focusSearch() {
      const input = document.querySelector('.search__input')
      const ahaslidesLogo = document.querySelector('.logo-merge-search-wrapper')
      input.style.visibility = 'visible'
      input.firstChild.focus()
      ahaslidesLogo.style.display = 'none'
    },
    unFocusSearch() {
      const ahaslidesLogo = document.querySelector('.logo-merge-search-wrapper')
      ahaslidesLogo.style.display = 'block'
      if (window.outerWidth < 1024) {
        const input = document.querySelector('.search__input')
        input.style.visibility = 'hidden'
      }
    },
    removeDisabled(event) {
      // autofill password error, hot-fix by read-only, detect click to remove readonly
      event.preventDefault()
      if (event.target.getAttribute('readonly') == 'readonly') {
        event.target.removeAttribute('readonly')
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.search--wrapper {
  &.disabled {
    @apply hidden;
  }
  .search__input {
    @apply cursor-pointer font-normal text-base;
    &:hover {
      .search__icon {
        @apply text-primary-90;
      }
    }
    &:focus-within {
      .search__icon {
        @apply text-primary-90;
      }
    }
  }
  &.has-text {
    .clear__icon {
      display: hidden;
      @media (min-width: 1024px) {
        display: block;
      }
    }
  }
  input {
    text-indent: 1.5rem !important;
  }
  .clear__icon {
    @apply absolute top-0 flex items-center h-10 text-base-60 right-2 hidden;
    &:hover {
      @apply text-primary-90;
    }
  }
  .search__icon {
    color: black;
  }
  &:focus-within {
    .trigger_search_icon {
      @apply hidden;
    }
  }
}

::v-deep .search__input input {
  padding-right: 1.75rem;
  padding-left: 2rem;
}
</style>
